import { Dex360AuditTabs } from './tabs';

export function Dex360Audit() {
	return (
		<>
			<div>
				<h1 className="mb-4 text-center text-2xl font-semibold">Dex 360 Audit</h1>
			</div>
			<Dex360AuditTabs />
		</>
	);
}
